"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getHomeAwayOdds_1 = __importDefault(require("./getHomeAwayOdds"));
function getTitlesAndLogos(_a) {
    var competitors = _a.competitors, odds = _a.odds;
    var homeLogo = competitors.homeLogo, awayLogo = competitors.awayLogo, homeTitle = competitors.homeName, awayTitle = competitors.awayName;
    var result = {
        homeLogo: homeLogo,
        awayLogo: awayLogo,
        homeTitle: homeTitle,
        awayTitle: awayTitle,
    };
    if (!odds)
        return result;
    var _b = getHomeAwayOdds_1.default({ odds: odds }), homeOdd = _b.homeOdd, awayOdd = _b.awayOdd;
    if (homeOdd) {
        result.homeOddId = homeOdd.id;
        if (homeOdd.competitorIds.length === 0) {
            result.homeLogo = '';
        }
        if (homeOdd.name) {
            result.homeTitle = homeOdd.name;
        }
    }
    if (awayOdd) {
        result.awayOddId = awayOdd.id;
        if (awayOdd.competitorIds.length === 0) {
            result.awayLogo = '';
        }
        if (awayOdd.name) {
            result.awayTitle = awayOdd.name;
        }
    }
    return result;
}
exports.default = getTitlesAndLogos;
//# sourceMappingURL=getTitlesAndLogos.js.map